var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-popover',{attrs:{"placement":"right","title":"","trigger":"hover"}},[_c('img',{style:({width: _vm.defaultWidth+'px',height:_vm.defaultHeight+'px'}),attrs:{"slot":"reference","src":_vm.imgSrc},slot:"reference"}),_c('img',{style:({width: _vm.defaultWidth*3+'px',height:'100%' }),attrs:{"src":_vm.imgSrc}})])
}
var staticRenderFns = []

export { render, staticRenderFns }